import { render } from "./calendar.vue?vue&type=template&id=6f870d0a"
import script from "./calendar.vue?vue&type=script&lang=js"
export * from "./calendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__